module.exports = __webpack_public_path__ + "static/media/LindaZonca.ad67b58a.webp";